import * as Yup from "yup";

export const AddQuestionSchema = Yup.object().shape({

    department: Yup.array().required("Select Permission To").min(1, " Select Permission To"),
    remark: Yup.string().notRequired("Enter Remark"),
    status: Yup.string().required("Select Status"),
    question: Yup.string().required("Enter Question"),
    right: Yup.string().required("Select Right Answer"),

    options: Yup.array().of(
        Yup.object().shape({
            opt: Yup.string().test(
                'opt',
                // 'Field 1 is required when Field 2 is empty',
                'Fill atleast one field',
                function (value) {
                    const { file } = this.parent;
                    return file || value;
                }
            ),
            file: Yup.string().test(
                'file',
                // 'Field 2 is required when Field 1 is empty',
                'Fill atleast one field',
                function (value) {
                    const { opt } = this.parent;
                    return opt || value;
                }
            ),
        })
    ),
});

export const CreateQuizSchema = Yup.object().shape({

    title: Yup.string().required("Enter Title"),
    department: Yup.array().required("Select Permission To").min(1, " Select Permission To"),
    status: Yup.string().required("Select Status"),
    question: Yup.array().min(2, 'Check at Least Two Rows').of(Yup.object().shape({}), 'Check at Least Two Rows'),
})

